import React, { Component } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";

import MetaTags from 'react-meta-tags';
import Helmet from 'react-helmet';
import Logo_b  from "../../../../assets/img/site/Logo.png";

import {
    Container,
    Row,
    Col
} from 'reactstrap';

import LayoutMaster from "../../../views/layout/Master";
import {layout} from "../../../../ts-helpers/decorators";

@layout(LayoutMaster)
class AboutPage extends Component<any> {
    state = {
        about_text:"",
        about_image:"",
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
       this.getData();
       this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get(`/abouts/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    about_text: data.about_text,
                    about_image: data.about_image,
                });
            })
    }

    render() {
        const {about_text,about_image}=this.state;

        return (
            <Container>
                <Helmet>
                    <title>About us / Skillers.co</title>
                    <meta name="keywords" content="" />
                    <meta name="description" content={about_text} />
                </Helmet>
                <Row>
                    <Col className="col-sm-8 col-sm-offset-2 about_block_image">
                        <img src={`${http.getDomain()}/${about_image}`} alt={about_image} />
                    </Col>
                </Row>
                <Row>
                    <Col className="col-sm-8 col-sm-offset-2 about_block" dangerouslySetInnerHTML={ { __html: about_text } }></Col>
                </Row>
            </Container>
        );
    }
}

export default AboutPage;
